enum IconSizes {
  XS = '12px',
  SM = '16px',
  MD = '20px',
  LG = '24px',
  XL = '48px',
  XXL = '68px',
}

export default IconSizes;
